import { useCallback, useState, useEffect } from "react";
import { useAIModelStore } from "../store/ai-model-store";

export const useModelFilters = () => {
  const { query, updateQuery } = useAIModelStore();
  const [localQuery, setLocalQuery] = useState(query);

  // Debounce search - 500ms bekle
  useEffect(() => {
    const timer = setTimeout(() => {
      if (localQuery !== query) {
        updateQuery(localQuery);
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [localQuery, query, updateQuery]);

  const handleQueryChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setLocalQuery(e.target.value);
    },
    []
  );

  return {
    query: localQuery,
    handleQueryChange,
  };
};
